import React from "react";

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;

const Payment = ({ formValues, setFormValues }) => {
    const handleCurrencyChange = (e) => {
        setFormValues((prev) => ({ ...prev, currency: e.target.value }));
    };

    const handleFormatChange = (e) => {
        setFormValues((prev) => ({ ...prev, format: e.target.value }));
    };
    const handlePaymentMethodToggle = (e) => {
        const method = e.target.value;
        const isChecked = e.target.checked;
    
        setFormValues((prev) => {
            const current = Array.isArray(prev.payment_methods) ? prev.payment_methods : [];
            const updated = isChecked
                ? [...current, method]
                : current.filter((m) => m !== method);
            return { ...prev, payment_methods: updated };
        });
    };
    
    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="w-[40%] bg-[#FFFFFF] flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl">
                <div className="flex flex-col w-full space-y-6">
                    {/* Currency */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.currency}
                            name="payment-pricing-currency"
                            onChange={handleCurrencyChange}
                        >
                            <option value="">Select Your Currency</option>
                            {Object.keys(EASYCOMMERCE.currencies).map((currency) => (
                                <option key={currency} value={currency}>
                                    {EASYCOMMERCE.currencies[currency]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency you want to use.
                        </p>
                    </div>

                    {/* Currency Format */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency Format
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.format}
                            name="payment-pricing-format"
                            onChange={handleFormatChange}
                        >
                            <option value="">Select Your Currency Format</option>
                            {Object.keys(EASYCOMMERCE.currency_format_options).map((format_option) => (
                                <option key={format_option} value={format_option}>
                                    {EASYCOMMERCE.currency_format_options[format_option]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency format you want to use.
                        </p>
                    </div>

                    {/* Payment Methods */}
                    {/*
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium mb-3">
                            Payment Method
                        </label>
                        <div className="space-y-4">
                            {Object.keys(EASYCOMMERCE.payment_methods).map((method) => {
                                return (
                                    <div key={method} className="flex items-center p-2 space-x-2">
                                        <input
                                            name="payment-methods-active_methods"
                                            type="checkbox"
                                            id={method}
                                            value={method}
                                            checked={formValues.payment_methods.includes(method)}
                                            onChange={(e) => handlePaymentMethodToggle(e)}
                                            className="easycommerce-checkbox-input"
                                        />
                                            <label
                                            htmlFor={method}
                                            className="flex items-center space-x-2 cursor-pointer text-ec-body text-[16px]"
                                        >
                                            <span className="capitalize">{method}</span>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    */}
                </div>
            </div>
        </div>
    );
};

export default Payment;
